import { LocaleKeys } from '../../../../locale/translation-types'

export enum LeaderFreeRateEnum {
  ALL_LEADERS_FREE = 'ALL_LEADERS_FREE',
  NO_FREE_RATE = 'NO_FREE_RATE',
  ONE_PER_TEN = 'ONE_PER_TEN',
  ONE_PER_FIFTEEN = 'ONE_PER_FIFTEEN',
  ONE_PER_TWENTY = 'ONE_PER_TWENTY',
  ONE_PER_TWENTY_FIVE = 'ONE_PER_TWENTY_FIVE',
  ONE_PER_THIRTY = 'ONE_PER_THIRTY'
}

export const leaderFreeRateEnumMapping: Record<LeaderFreeRateEnum, LocaleKeys> = {
  [LeaderFreeRateEnum.ALL_LEADERS_FREE]: 'leader.free.rate.enum.ALL_LEADERS_FREE',
  [LeaderFreeRateEnum.NO_FREE_RATE]: 'leader.free.rate.enum.NO_FREE_RATE',
  [LeaderFreeRateEnum.ONE_PER_TEN]: 'leader.free.rate.enum.ONE_PER_TEN',
  [LeaderFreeRateEnum.ONE_PER_FIFTEEN]: 'leader.free.rate.enum.ONE_PER_FIFTEEN',
  [LeaderFreeRateEnum.ONE_PER_TWENTY]: 'leader.free.rate.enum.ONE_PER_TWENTY',
  [LeaderFreeRateEnum.ONE_PER_TWENTY_FIVE]: 'leader.free.rate.enum.ONE_PER_TWENTY_FIVE',
  [LeaderFreeRateEnum.ONE_PER_THIRTY]: 'leader.free.rate.enum.ONE_PER_THIRTY'
}
